/**
 * Controller for AppManager
 */
define('controllers/mysetting/teamaccount/add.member.account.ctrl',['app'], function (app) {
    app.controller('AddMemberAccountCtrl', ['$q', '$scope', '$location', '$stateParams', '$state',
        function ($q, $scope, $location, $stateParams, $state) {
            var Model = $scope.Model = {};
            Model.stepsConf = [{name: $stateParams.teamMemberInfo && $stateParams.teamMemberInfo.fakeMemberID ?'修改成员信息':'添加成员帐号', mapState: ['mysetting.addMemberAccount.account']}, {
                name: '设置角色与权限',
                mapState: ['mysetting.addMemberAccount.rolePermission']
            }, {name: '帐号信息确认', mapState: ['mysetting.addMemberAccount.confirm']}];

            if($location.url() =='/mysetting/addMemberAccount'){
                $state.go('mysetting.addMemberAccount.account',{teamMemberInfo:$stateParams.teamMemberInfo,memberResInfo:$stateParams.memberResInfo});
            }
        }]);
});
